import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.93671 4.2041L2.14063 12.0006M2.14063 12.0006L9.93671 19.7967M2.14063 12.0006C9.01819 12.0006 22.1406 12.0006 22.1406 12.0006",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }